import React, { useState } from "react";
import { StyleSheet } from "react-native";
import { Button, LoadingBox } from "components";

import axios from "axios";
import * as XLSX from "xlsx";
import download from "downloadjs";

const GetAllCustomers = () => {
  const [isLoading, setIsLoading] = useState(false);

  const excelMimType =
    "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";

  const _onExcel = (customers) => {
    if (customers.length > 0) {
      const json = customers?.map((u: CustomerT) => {
        return {
          //اصلی
          نام: u?.name,
          موبایل: u?.mobile,
          "ایجاد کننده": u?.seller,
          نوع: u?.status?.title,
          گروه: u?.category?.title,
          "نحوه آشنایی": u?.frindship?.title,
          "شرکت های همکار": u?.colleagues?.map((e) => e?.name).join(" - "),
          شهر: u.cityName,
          کشور: u?.addresses?.map((e) => e?.country?.text).join(" - "),
          استان: u?.addresses?.map((e) => e?.province?.text).join(" - "),
          شهرها: u?.addresses?.map((e) => e?.city?.text).join(" - "),
          آدرس: u?.addresses?.map((e) => e?.address).join(" - "),
          "آدرس کامل": u?.addresses
            ?.map(
              (e) =>
                `${e?.country?.text ?? ""} - ${e?.province?.text ?? ""} - ${
                  e?.city?.text ?? ""
                } - ${e?.address ?? ""}`
            )
            .join(" | "),
          "خصوصیات شخصی": u?.characteristics,
          "نام فروشگاه": u?.shop?.name,
          "وضعیت مالکیت": u?.shop?.owner_type?.title,
          شریک:
            u?.shop?.has_partner === 0
              ? "ندارد"
              : u?.shop?.has_partner === 1
              ? "دارد"
              : "",

          "(متر مربع) متراژ": u?.shop?.area,
          "زمان اجاره (تعداد سال)": u?.shop?.rental_period,
          "تعداد شعبه": u?.shop?.branch,
          "تعداد کارکنان": u?.shop?.employee,
          "مدت زمان فعالیت (سال)": u?.shop?.activity_duration,
          "تعداد رگال": u?.shop?.regal,
          سمت: u?.job,
          "شغل دیگر صاحب مغازه": u?.shop?.other_jobs,
          "توضیحات فروشگاه": u?.shop?.description,
          "محصولات پر استفاده": u?.shop?.popular_products
            ?.map((e) => e?.title)
            .join(" - "),
          "گروه های پر استفاده": u?.shop?.popular_categories
            ?.map((e) => e?.title)
            .join(" - "),
          "ویژگی های پر استفاده": u?.shop?.popular_attributes
            ?.map(
              (e) => `${e?.title}: ${e.items?.map((a) => a.value).join(" , ")}`
            )
            .join(" - "),

          //تکمیلی
          "کد ملی": u?.national_code,
          مذهب: u?.religion?.title,
          تلفن: u?.phone?.map((p) => p.number).join(" , "),
          "شبکه اجتماعی": u?.social?.map((s) => s.address)?.join(" , "),
          ایمیل: u?.email?.join(" , "),
          "وب سایت": u?.website,
          تولد: u?.birthday,
          "تاریخ آشنایی": u?.friendship_at,
          "زمان حضور در کاشان": u?.facing_meeting,
          "توضیحات تکمیلی": u?.description,
          // اعتباری
          "نحوه خرید": u?.credit?.buy_type?.title,
          "اعتبار مشتری": u?.credit?.status?.title,
          "قدرت خرید(تعداد در ماه)": u?.credit?.power_buy_monthly,
          "زمان افتتاح حساب بانکی": u?.credit?.open_account_at,
          "حداکثر مبلغ چک های پاس شده (تومان)": u?.credit?.passed_cheque_amount,
          "تعداد چک های برگشتی": u?.credit?.returned_cheque_count,
          "استعلام حضوری": u?.credit?.search_description,
          "استعلام از همکاران": u?.credit?.colleague_description,
          "استعلام نهایی": u?.credit?.description,
        };
      });
      var ws = XLSX.utils.json_to_sheet(json);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Cities");
      const wbOut = XLSX.write(wb, {
        type: "base64",
        bookType: "xlsx",
      });
      download(excelMimType + wbOut, "all-customers.xlsx", excelMimType);
      setIsLoading(false);
    }
  };

  const getCustomers = (pageId: number, customers) => {
    setIsLoading(true);
    axios.get("customer?page=" + pageId).then((res) => {
      customers = [...customers, ...res?.data?.data];
      if (res?.data?.links?.next) {
        getCustomers(pageId + 1, customers);
      } else {
        _onExcel(customers);
      }
    });
  };

  return (
    <>
      <Button
        mv={10}
        width={160}
        title={{ value: `همه مشتریان`, weight: "bold" }}
        onPress={() => getCustomers(1, [])}
        icon={{
          type: "materialCommunity",
          name: "microsoft-excel",
          size: 35,
        }}
      />

      {isLoading && <LoadingBox />}
    </>
  );
};

export default GetAllCustomers;

const styles = StyleSheet.create({});
